import React from "react";

export const LanguageToggle = ({setLang, lang}) =>
  <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-8 lg:px-8">
    {/* Language toggle with flags */}
    <div className="flex items-center justify-end space-x-2">
      <span className="sr-only">Language</span>
      <button
        type="button"
        onClick={() => setLang("nl")}
        aria-pressed={lang === "nl"}
        className={`inline-flex items-center px-3 py-1 rounded-md border ${
          lang === "nl"
            ? "bg-blue-700 text-white border-blue-700"
            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
        }`}
        title="Nederlands"
      >
        NL
      </button>
      <span className="text-gray-300">|</span>
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={`inline-flex items-center px-3 py-1 rounded-md border ${
          lang === "en"
            ? "bg-blue-700 text-white border-blue-700"
            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
        }`}
        title="English"
      >
        EN
      </button>
    </div>
  </div>